import { render, staticRenderFns } from "./MyAI.vue?vue&type=template&id=032b0de0&scoped=true&"
import script from "./MyAI.vue?vue&type=script&lang=js&"
export * from "./MyAI.vue?vue&type=script&lang=js&"
import style0 from "./MyAI.vue?vue&type=style&index=0&id=032b0de0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032b0de0",
  null
  
)

export default component.exports